module.exports = __webpack_public_path__ + "static/5-insights-31b1ef2a7390425a9fa0fb85d80f663a.jpg";